export interface Interest {
  name: string;
  emoji: string;
}

// Interests list with name as the identifier
export const INTERESTS: Interest[] = [
  { name: "Basic Phrases", emoji: "👋" },
  { name: "Travel", emoji: "✈️" },
  { name: "Business", emoji: "💼" },
  { name: "Food", emoji: "🍔" },
  { name: "Culture", emoji: "🏛️" },
  { name: "Slang", emoji: "🤙" },
  { name: "Humor", emoji: "😂" },
  { name: "Music", emoji: "🎵" },
  { name: "Movies", emoji: "🎬" },
  { name: "Technology", emoji: "💻" },
  { name: "Sports", emoji: "⚽" },
  { name: "Health", emoji: "🏥" },
  { name: "Fashion", emoji: "👗" },
  { name: "Science", emoji: "🧪" },
  { name: "History", emoji: "📜" },
  { name: "Art", emoji: "🎨" },
  { name: "Literature", emoji: "📚" },
  { name: "Politics", emoji: "🏛️" },
  { name: "Environment", emoji: "🌱" },
  { name: "Relationships", emoji: "❤️" },
  { name: "Education", emoji: "🎓" },
  { name: "Shopping", emoji: "🛍️" },
  { name: "Gaming", emoji: "🎮" },
  { name: "Social Media", emoji: "📱" },
  { name: "Finance", emoji: "💰" },
  { name: "Weather", emoji: "🌤️" },
  { name: "Nature", emoji: "🌳" },
  { name: "Animals", emoji: "🐾" },
  { name: "Cooking", emoji: "👨‍🍳" },
  { name: "DIY", emoji: "🔨" },
  { name: "Photography", emoji: "📷" },
  { name: "Podcasting", emoji: "🎙️" },
  { name: "Meditation", emoji: "🧘" },
  { name: "Fitness", emoji: "🏋️" },
  { name: "Yoga", emoji: "🧘‍♀️" },
  { name: "Astronomy", emoji: "🔭" },
  { name: "Gardening", emoji: "🌿" },
  { name: "Cars", emoji: "🚗" },
  { name: "Cycling", emoji: "🚴‍♂️" },
  { name: "Hiking", emoji: "🥾" },
  { name: "Architecture", emoji: "🏗️" },
  { name: "Philosophy", emoji: "🤔" },
  { name: "Theater", emoji: "🎭" },
  { name: "Dance", emoji: "💃" },
  { name: "Martial Arts", emoji: "🥋" },
  { name: "Board Games", emoji: "🎲" },
  { name: "Coding", emoji: "👨‍💻" },
  { name: "Artificial Intelligence", emoji: "🤖" },
  { name: "Mathematics", emoji: "➗" },
  { name: "Chess", emoji: "♟️" },
  { name: "Camping", emoji: "⛺" },
  { name: "Surfing", emoji: "🏄" },
  { name: "Skiing", emoji: "🎿" },
  { name: "Snowboarding", emoji: "🏂" },
  { name: "Scuba Diving", emoji: "🤿" },
  { name: "Skateboarding", emoji: "🛹" },
  { name: "Magic", emoji: "🪄" },
  { name: "Astrology", emoji: "♈" },
  { name: "Wine Tasting", emoji: "🍷" },
  { name: "Coffee", emoji: "☕" },
];

interface InterestsSelectorProps {
  selectedInterests: string[];
  onChange: (selectedInterests: string[]) => void;
  minRequired?: number;
}

export default function InterestsSelector({ selectedInterests, onChange, minRequired = 0 }: InterestsSelectorProps) {
  const toggleSelection = (name: string) => {
    onChange(
      selectedInterests.includes(name)
        ? selectedInterests.filter((item) => item !== name)
        : [...selectedInterests, name]
    );
  };

  return (
    <div>
      {minRequired > 0 && (
        <div className="mb-2 text-sm text-gray-600">
          {selectedInterests.length >= minRequired
            ? `Selected: ${selectedInterests.length}`
            : `Please select at least ${minRequired} interests (${selectedInterests.length}/${minRequired})`}
        </div>
      )}

      <div className="max-h-[60vh] sm:max-h-[300px] overflow-y-auto pr-2">
        <div className="flex flex-row flex-wrap gap-2">
          {INTERESTS.map((interest) => (
            <div
              key={interest.name}
              onClick={() => toggleSelection(interest.name)}
              className={`flex items-center px-2 sm:px-3 py-1 rounded-full border cursor-pointer transition-all text-sm sm:text-base ${
                selectedInterests.includes(interest.name)
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
              }`}
            >
              <div className="text-lg sm:text-xl mr-1 sm:mr-2">{interest.emoji}</div>
              <div className="font-medium truncate">{interest.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
